module.exports = __webpack_public_path__ + "img/tool.af5ba72f.png";